import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Loader, Button } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  ButtonCriar,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../../services/auth";
import Select, { createFilter } from "react-select";

const AtualizacaoPremium = (props) => {
  const [search, setSearch] = useState("");
  const [cursos, setCursos] = useState([]);
  const [allCursos, setAllCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const addCurso = useRef(0);

  useEffect(() => {
    loadAuth();
    loadCombo();
  }, []);

  const loadCombo = async () => {
    api
      .get("combo/detalhes/4134")
      .then(async (res) => {
        const newArray = res.data.filter(curso => curso != null && (curso.tipo == 3 && curso.ativo == 'S'));
        setCursos([...cursos, ...newArray]);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar o combo", err, "").then((res) =>
          props.history.push("/")
        );
      });
  }

  const loadAll = (value) => {
    setAllCursos([]);
    api
      .get(`cursos-simplelist?limit=20&search=${value}`)
      .then(async res => {
        const newCurso = res.data.map(curso => ({
          name: curso.id + " - " + curso.curso,
          label: curso.id + " - " + curso.curso,
          value: curso.id,
        }))
        setAllCursos([...newCurso])
      }).catch((err) => {
        swal("Não foi possível carregar os cursos", err, "")
      });

  }

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const cursoSetter = (value) => {
    if (value != null && value != undefined) {
      addCurso.current = value.value;
    }
  }

  const handleSend = () => {
    if (addCurso.current == 0) {
      swal("Por favor escolha um curso", '', "error");
      return;
    }
    const valor = cursos.filter(curso => curso.id == addCurso.current)

    if (valor.length > 0) {
      swal("Este curso já está no combo!!!", '', "error");
    } else {
      api
        .post('premium/send', { curso: addCurso.current })
        .then(async res => {

          let logs = { local: "ead/atualizacao-premium", texto: `adicionou o curso ${addCurso.current} do combo 4134` };
          await api.post("system_logs", { acao: JSON.stringify(logs) });

          swal("Curso adicionado com sucesso", '', "success")
        }).catch(err => swal(err, '', "error"))
    }
  }

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Atualização Premium</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar cursos..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

            </ContainerInputSearch>
            <ContainerInputSearch>
              <div className='select'>
                <Select
                  onInputChange={(e) => loadAll(e)}
                  onChange={(e) => { cursoSetter(e) }}
                  defaultValue={""}
                  isClearable
                  isSearchable
                  options={allCursos}
                  placeholder="Busque o curso pelo id ou pelo nome"
                  filterOption={createFilter({
                    ignoreCase: true,
                    ignoreAccents: true,
                    trim: false,
                    matchFromStart: false,
                  })}
                />
              </div>
              <ButtonCriar onClick={handleSend}>Adicionar</ButtonCriar>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {cursos
                  .filter((curso) =>
                    curso.curso
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((curso, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{curso.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{curso.curso}</SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(AtualizacaoPremium);
